{
    "(save {highestYearlyDiscount}%)": "",
    "{amount} days free": "{amount} dní zdarma",
    "{amount} off": "{amount} zľava",
    "{amount} off for first {number} months.": "Zľava {amount} pre prvé {number} mesiace.",
    "{amount} off for first {period}.": "Zľava {amount} pre prvé {period}.",
    "{amount} off forever.": "Zľava {amount} navždy",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_few": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_many": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "Zľava {discount}%",
    "{duration} membership": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} už nebude dostávať {newsletterName} newsletter.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} už nebude dostávať e-maily, keď niekto odpovie na vaše komentáre.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} už nebude dostávať tento newsletter.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} dní zdarma",
    "{years} years": "",
    "+1 (123) 456-7890": "",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Účet",
    "Account details updated successfully": "Podrobnosti o účte boli úspešne aktualizované",
    "Account settings": "Nastavenia účtu",
    "Add a personal note": "",
    "Add a short note to go with your gift": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Po uplynutí skúšobného obdobia vám bute účtovaná bežná cena pre vybrunú úrovenň. Vždy to môžte pred tým zrušiť",
    "Already a member?": "Ste už členom?",
    "An error occurred": "Vyskytla sa chyba",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "Nastala neočakávaná chyba. Prosím skúste neskôr alebo <a>kontaktujte podporu</a> ak problém pretrváva.",
    "Back": "Späť",
    "Back to Log in": "Späť na prihlásenie",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "",
    "Bluesky": "",
    "Buy": "",
    "Buying for someone else?": "",
    "Cancel anytime.": "Zrušiť kedykoľvek",
    "Cancel subscription": "Zrušiť odber",
    "Canceled": "",
    "Cancellation reason": "Dôvod zrušenia",
    "Change": "Zmena",
    "Change plan": "Zmeniť plán",
    "Check spam & promotions folders": "Skontrolujte priečinky spam a reklamy",
    "Check with your mail provider": "Overte si to s vašim e-mailovým poskytovateľom.",
    "Check your inbox to verify email update": "Skontrolujte si doručenú poštu a overte si aktualizáciu e-mailu",
    "Choose": "Vybrať",
    "Choose a date from today onwards": "",
    "Choose a date within the next year": "",
    "Choose a delivery date": "",
    "Choose a different plan": "Vybrať iný plán",
    "Choose a plan": "Vyberte si plán",
    "Choose a tier": "",
    "Choose your newsletters": "Vyberte si newsletter",
    "Click here to retry": "Kliknite sem pre obnovenie",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Zatvoriť",
    "Code": "",
    "Comment preferences updated.": "Nastavenia komentárov aktualizované",
    "Comments": "Komentáre",
    "Complimentary": "Bezplatné",
    "Confirm": "Potvrdiť",
    "Confirm cancellation": "Potvrdiť zrušenie",
    "Confirm subscription": "Potvrdiť odber",
    "Contact support": "Kontaktovať podporu",
    "Continue": "Pokračovať",
    "Continue subscription": "Pokračovať s odberom",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "Nepodarilo sa vytvoriť reláciu platby cez Stripe",
    "Could not sign in. Login link expired.": "Prihlásenie sa nepodarilo. Odkaz na prihlásenie vypršal.",
    "Could not update email! Invalid link.": "Zmena e-mailu sa nepodarila. Neplatný odkaz.",
    "Create a new contact": "Vytvoriť nový kontakt",
    "Current plan": "Aktuálny plán",
    "Delete account": "Vymazať účet",
    "Delivery date": "",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "Nechceli ste to urobiť? Spravujte svoje nastavenia <button>tu</button>.",
    "Don't have an account?": "Ešte nemáte účet?",
    "Edit": "Upraviť",
    "Email": "E-mail",
    "Email confirmation link expired.": "",
    "Email it to them": "",
    "Email newsletter": "E-mail newsletteru",
    "Email newsletter settings updated": "Nastavenia e-mailu newslettera aktualizované",
    "Email preferences": "E-mailové nastavnia",
    "Email preferences updated.": "Nastavenia emailu aktualizované",
    "Emails": "E-maily",
    "Emails disabled": "E-maily vypnuté",
    "Ends {offerEndDate}": "Vyprší {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter the recipient's email address": "",
    "Enter your email address": "Zadajte svoju e-mailovú adresu",
    "Enter your name": "Zadajte svoje meno",
    "Error": "Chyba",
    "Expires {expiryDate}": "Vyprši {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "Nepodarilo sa zrušiť predplatné, prosím skúste to znova",
    "Failed to log in, please try again": "Prihlásenie sa nepodarilo, prosím skúste to znova",
    "Failed to log out, please try again": "Odhlásenie sa nepodarilo, prosím skúste to znova",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "Platbu sa nepodarilo spracovať, prosím skúste to znova",
    "Failed to send magic link email": "Nepodarilo sa poslať email so zázračným odkazom.",
    "Failed to send verification email": "Nepodarilo sa poslať verifikačný email",
    "Failed to sign up, please try again": "Registrácia zlyhala, skúste to prosím znova",
    "Failed to update account data": "Nepodarilo sa aktualizovať dáta o účte",
    "Failed to update account details": "Nepodarilo sa aktualizovať podrobnosti o účte",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "Nepodarilo sa aktualizovať nastavenia newslettera",
    "Failed to update subscription, please try again": "Zlyhala aktualizácia odberu, prosím skúste to znova.",
    "Failed to verify code, please try again": "",
    "For a friend or colleague": "",
    "Forever": "Navždy",
    "Free Trial – Ends {trialEnd}": "Skúšobná verzia – Vyprší {trialEnd}",
    "From": "",
    "Get help": "Získať pomoc",
    "Get in touch for help": "Obrátiť sa na pomoc",
    "Get notified when someone replies to your comment": "Dostávať upozornenie, ak niekto odpíše na komentár",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift membership": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Dať spätnú väzbu na tento príspevok",
    "Help! I'm not receiving emails": "Pomoc! Nedostávam e-maily",
    "Here are a few other sites you may enjoy.": "Tu je niekoľko ďalších stránok, ktoré sa vám môžu páčiť.",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Ak je newsletter označený ako spam, e-maily sa pre danú adresu automaticky zakážu, aby ste už nedostávali žiadne nevyžiadané správy.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Ak bola sťažnosť na nevyžiadanú poštu náhodná alebo ak chcete opäť začať dostávať e-maily, môžete sa k odberu e-mailov opätovne prihlásiť kliknutím na tlačidlo na predchádzajúcej obrazovke.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Ak teraz zrušíte svoje predplatné, budete mať prístup až do {periodEnd}.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Ak máte firemné alebo štátne e-mailové konto, obráťte sa na svoje IT oddelenie a požiadajte ho, aby povolilo prijímanie e-mailov z adresy {senderEmail}.",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Prihlasovací odkaz bol odoslaný na váš e-mail. Ak nedorazi do 3 minút, skontrolujte priečinok so spamom",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Ak chcete opäť začať dostávať e-maily, najlepšie je skontrolovať, či vaša e-mailová adresa v súbore neobsahuje nejaké problémy, a potom kliknúť na možnosť opätovného prihlásenia na predchádzajúcej obrazovke.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Ak nedostávate newsletter, ku ktorému ste sa prihlásili, tu je niekoľko vecí, ktoré treba skontrolovať.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Ak ste vykonali všetky kontroly a stále nedostávate e-maily, môžete sa obrátiť na podporu a kontaktovať  {supportAddress}.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "V prípade, že pri pokuse o odoslanie newslettera dôjde k trvalému zlyhaniu, e-maily budú na účte vypnuté.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "V e-mailovom klientovi pridajte {senderEmail} do zoznamu kontaktov. Tým poskytovateľovi e-mailovej služby signalizujete, že e-maily odoslané z tejto adresy sú dôveryhodné.",
    "Invalid email address": "Nesprávna emailová adresa",
    "Invalid verification code": "",
    "Jamie Larson": "Peter Kováč",
    "jamie@example.com": "peter@príklad.com",
    "Less like this": "Menej podobných",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Uistite sa, že e-maily omylom nekončia v priečinkoch Spam alebo Reklamy. Ak sa tak deje, kliknite na „Toto nie je spam“ a/alebo „Presunúť do doručenej pošty“.",
    "Manage": "Spravovať",
    "Maybe later": "Možno neskôr",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": "Členstvá nie sú k dispozícii, pre prístup kontaktujte vlastníka stránky.",
    "month": "mesiac",
    "Monthly": "Mesačne",
    "More like this": "Viac podobných",
    "More options": "",
    "Name": "Meno",
    "Need more help? Contact support": "Potrebujete pomoc? Kontaktujte podporu",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "Newsletter môže byť na vašom účte zakázaný z dvoch dôvodov: Predchádzajúci e-mail bol označený ako spam alebo pokus o odoslanie e-mailu viedol k trvalému zlyhaniu (bounce).",
    "No member exists with this e-mail address.": "Používateľ s danou emailovou adresou neexistuje.",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Nedostávate e-maily?",
    "Now": "",
    "Now check your email!": "Skontrolujte svoju emailovú schránku!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Ak po opätovnom prihlásení stále nevidíte e-maily v doručenej pošte, skontrolujte priečinok so spamom. Niektorí poskytovatelia schránok uchovávajú záznamy o predchádzajúcich sťažnostiach na nevyžiadanú poštu a budú naďalej označovať e-maily. Ak sa tak stane, označte najnovší newsletter ako „Nie je spam“, aby ste ho presunuli späť do primárnej schránky.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "Trvalá chyba (bounce)",
    "Phone number": "Telefónne číslo",
    "Plan": "Plán",
    "Plan checkout was cancelled.": "Platba za plán bola zrušená.",
    "Plan upgrade was cancelled.": "Upgrade plánu bol zrušený",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "Prosím kontaktujte {supportAddress} pre upravenie vášho bezplatného predplatného.",
    "Please enter {fieldName}": "Prosím zadajte {fieldName}",
    "Please fill in required fields": "Prosím vyplňte požadované polia.",
    "Podcasts": "",
    "Re-enable emails": "Obnoviť emaily",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "Odporúčania",
    "Redeem your gift": "",
    "Redeem your membership": "",
    "Redeeming...": "",
    "Renews at {price}.": "Obnoviť za {price}.",
    "Resume subscription": "",
    "Retry": "Skúsiť znovu",
    "Save": "Uložiť",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Odosielanie prihlasovacieho odkazu...",
    "Sending...": "Odosielanie...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "Zobraziť všetko",
    "Sign in": "Prihlásiť sa",
    "Sign out": "Odhlásiť sa",
    "Sign up": "Registrovať sa",
    "Signup error: Invalid link": "Chyba registrácie: Neplatný odkaz",
    "Signups from this email domain are currently restricted.": "",
    "Something went wrong, please try again later.": "Niečo sa pokazilo, skúste to prosím neskôr.",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "Prepáčte, momentálne nie sú dostupné žiadne odporúčania.",
    "Sorry, that didn’t work.": "Prepáčte, toto nezafungovalo.",
    "Spam complaints": "Sťažnosti na spam",
    "Start {amount}-day free trial": "Začať {amount}-dňovú skúšobnú dobu",
    "Starting {startDate}": "Začína {startDate}",
    "Starting today": "Začina dnes",
    "Submit feedback": "Odoslať spätnú väzbu",
    "Subscribe": "Odoberať",
    "Subscribed": "Prihásený k odberu",
    "Subscription plan updated successfully": "Plán predplatného úspešne aktualizovaný",
    "Success": "Úspech",
    "Success! Check your email for magic link to sign-in.": "Super! Skontrolujte Vašu emailovú schránku, kde nájdete odkaz na prihlásenie.",
    "Success! Your account is fully activated, you now have access to all content.": "Super! Váš účet je aktivovaný. Máte prístup ku všetkému obsahu.",
    "Success! Your email is updated.": "Super! Váš e-mail bol zmenený.",
    "Successfully unsubscribed": "Úspešne odhlásený z odberu",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "Ďakujeme za odber. Skôr ako začnete čítať, nižšie nájdete niekoľko ďalších stránok, ktoré sa vám môžu páčiť.",
    "Thank you for your support": "Ďakujeme za Vašu podporu",
    "Thank you for your support!": "Ďakujeme za Vašu podporu!",
    "Thanks for the feedback!": "Ďakujeme za spätnú väzbu!",
    "That didn't go to plan": "Niečo sa nepodarilo",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "Emailovú adresu, ktorú pre vás máme je {memberEmail} - Ak to nie je správne môžete to zmeniť v <button>nastaveniach účtu</button>.",
    "There was a problem submitting your feedback. Please try again a little later.": "Nepodarilo sa odoslať váš feedback. Prosím skúste to neskôr.",
    "There was an error cancelling your subscription, please try again.": "Pri zrušení vášho predplatného došlo k chybe, skúste to prosím znova.",
    "There was an error continuing your subscription, please try again.": "Pri predĺžení vášho predplatného sa vyskytla chyba, prosím skúste to znovu",
    "There was an error processing your payment. Please try again.": "Pri spracovaní vašej platby došlo k chybe. Skúste to prosím znova.",
    "There was an error sending the email, please try again": "Pri odosielaní e-mailu došlo k chybe, skúste to prosím znova",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "Táto stránka je iba pre pozvaných úžívateľov, kontaktujte vlastníka stránky.",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "Táto stránka momentálne neprijíma platby.",
    "This site only accepts paid members.": "",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Ak chcete dokončiť registráciu, kliknite na potvrdzujúci odkaz v doručenej pošte. Ak vám nepríde do 3 minút, skontrolujte priečinok so spamom!",
    "To continue to stay up to date, subscribe to {publication} below.": "Ak chcete byť aj naďalej informovaný o novinkách, prihláste sa na odber od {publication} nižšie.",
    "Too many attempts try again in {number} days.": "Príliš veľa pokusov, skúste to znova za {number} dní.",
    "Too many attempts try again in {number} hours.": "Príliš veľa pokusov, skúste to znova o {number} hodín.",
    "Too many attempts try again in {number} minutes.": "Príliš veľa pokusov, skúste to znova o {number} minút.",
    "Too many different sign-in attempts, try again in {number} days": "Príliš veľa pokusov o prihlásenie, skúste to znova o {number} dní.",
    "Too many different sign-in attempts, try again in {number} hours": "Príliš veľa pokusov o prihlásenie, skúste to znova o {number} hodín.",
    "Too many different sign-in attempts, try again in {number} minutes": "Príliš veľa pokusov o prihlásenie, skúste to znova o {number} minút.",
    "Too many sign-up attempts, try again later": "",
    "Try free for {amount} days, then {originalPrice}.": "Vyskúšajte zadarmo na {amount} dní, potom {originalPrice}",
    "Unable to initiate checkout session": "Nie je možné spustiť reláciu pre platbu",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Odomknite si prístup ku všetkým newsletterom, ak sa stanete plateným predplatiteľom.",
    "Unsubscribe from all emails": "Odhlásiť sa z odberu všetkých emailov",
    "Unsubscribed": "Odhlásený z odberu",
    "Unsubscribed from all emails.": "Odhlásený z odberu všetkých emailov",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Odhlásením z odberu emailov sa nezruší vaše platené predplatné pre {title}",
    "Update": "Upraviť",
    "Update your preferences": "Upraviť nastavenia",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "Odkaz na overenie bol odoslaný, skontrolujte prosím svoju emailovú schránku",
    "Verify your email address is correct": "Overte že Vaša emailová adresa je správna",
    "Verifying...": "",
    "View plans": "Prezrieť plány",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Nepodarilo sa nám vymazať z odberu váš email, pretože nebol nenájdený. Prosím kontaktujte vlastníka stránky.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "Vitaje späť, {name}!",
    "Welcome back!": "Vitajte späť!",
    "Welcome to {siteTitle}": "Vitajte na {siteTitle}",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Keď schránka neprijme e-mail, bežne sa to nazýva odmietnutie (bounce). V mnohých prípadoch môže ísť o dočasný jav. V niektorých prípadoch sa však môže vrátiť ako trvalý neúspech, keď je e-mailová adresa neplatná alebo neexistuje.",
    "Why has my email been disabled?": "Prečo bol môj email deaktivovaný?",
    "X (Twitter)": "",
    "year": "rok",
    "Yearly": "Ročne",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "Aktuálne máte bezplatné členstvo, inovujte na platené predplatné, aby ste získali plný prístup.",
    "You have been successfully resubscribed": "Vaše predplatné bolo úspešne obnovené",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "Aktuálne nepríjimate emaily",
    "You're not receiving emails": "Nedostávate emaily",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Nepríjimate email-y lebo váša posledná správa bola označená ako spam, alebo správy nemohli byť doručené na vašu email-ovú adresu.",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_few": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_many": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_other": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_few": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_many": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "You've been gifted a membership": "",
    "You've been gifted a membership to {siteTitle}": "",
    "You've successfully signed in.": "Úspešne ste sa prihlásili",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "Úspešne ste sa prihlásili na odber pre <strong>{siteTitle}</strong>",
    "Your account": "Váš účet",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "Váš email zlyhal pri obnovení predplatného, prosím skúste to znova",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift is scheduled": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "Vaše pripomienky pomáhajú spoluvytvárať obsah webu.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "Váše predplatné expiruje {expiryDate}",
    "Your subscription will renew on {renewalDate}": "Váše predplatné bude obnovené {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "Váše predplatné začína {subscriptionStart}"
}
